import React, { useEffect, useState } from 'react'
import styles from './ShopByCategoryDetails.module.scss'
import BrowseByType from './BrowseByType'
import ShopByCategoryOthers from './ShopByCategoryOthers'
import FeaturedProducts from './FeaturedProducts'
import NewArrivals from './NewArrivals'
import HotWatches from './HotWatches'
import SpecialOffers from './SpecialOffers'
import OfferBanners from './OfferBanners'
import JewelryStore from 'src/components/Jewelry/JewelryStore'
import JewelryClubs from 'src/components/Jewelry/JewelryClubs'
import AllProduct from 'src/components/ProductPage/AllProduct'
import { useSelector } from 'react-redux'
import { fetchProductByCategory, setProductByCategoryState } from 'src/store/slices/fetchAllProduct'
import { useAppDispatch } from 'src/store/store'
import Weekofoffersection from '../MainCategory/WomenCategory/WomanPageModal/Weekoffersection'

export default function ShopByCategoryDetails({
  category_id,
  subCategory_id,
  storetitle,
  storeModalName,
  clubTitle,
  dataLimite,
  setPage,
  page,
}) {
  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const dispatch = useAppDispatch()
  const [filterData, setFilterData] = useState<any>({ subCategory: [], category: [] })

  useEffect(() => {
    setPage(1)
    fetchProduct()
  }, [])

  const fetchProduct = () => {
    dispatch(
      fetchProductByCategory({
        category: 'fashion-and-accessories',
        subCategory: 'men',
        childSubCategory: '',
        isShopifyProduct: false,
        page: page,
        limit: dataLimite,
      }),
    )
  }

  const fetchUpdatedProduct = (product_id, type) => {
    let update_product = []
    if (type === 'dislike') {
      update_product = productByCategory?.product?.getAllProducts?.total?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: null,
          }
        } else {
          return prd
        }
      })
    } else if (type === 'like'){
      update_product = productByCategory?.product?.getAllProducts?.total?.map((prd) => {
        if (prd?.id === product_id) {
          return {
            ...prd,
            likes: {
              id: 3.3333,
            },
          }
        } else {
          return prd
        }
      })
    }
    dispatch(
      setProductByCategoryState({
        getAllProducts: {
          data: update_product,
        },
      }),
    )
    fetchProduct()
  }

  return (
    <div className={styles.shopByCategorySection}>
      <div className="container mobile-view-padding-zero" style={{ maxWidth: '1300px' }}>
        <div>
          {/* <BrowseByType /> */}
          {/* <ShopByCategoryOthers /> */}
          {/* <FeaturedProducts /> */}
          {/* <NewArrivals /> */}
          <div className={styles.shopByCategoryChildDetails}>
            <HotWatches />
            <SpecialOffers backgroundColor={'rgba(33, 62, 78, 0.40)'} />
          </div>

          <Weekofoffersection />
          {/* <OfferBanners /> */}
          {/* <JewelryStore
            category_id={category_id}
            subCategory_id={subCategory_id}
            title={storetitle}
            modalName={storeModalName}
          /> */}
          <JewelryClubs title={clubTitle} />
          {/* <div className="product-alignment-mobile">
            <AllProduct
              products={productByCategory?.product?.getAllProducts?.data}
              storeId={0}
              color={'#FFFFFF'}
              isFilterMenu={true}
              total={productByCategory?.product?.getAllProducts?.total}
              dataLimite={dataLimite}
              setPage={setPage}
              page={page}
              topForFilter={100}
              mobileTopForFilter={67}
              isCalled={productByCategory?.called}
              setFilterData={setFilterData}
              filterData={filterData}
              APIcall={fetchUpdatedProduct}
            />
          </div> */}
        </div>
      </div>
    </div>
  )
}
